import { IsArray, IsString, IsNotEmpty } from 'class-validator';
import { Type } from 'class-transformer';

export class TimezoneExceptionDto {
  @IsString()
  @IsNotEmpty()
  timezoneId: string;

  @Type(() => String)
  @IsArray()
  @IsNotEmpty()
  employees: string[];
}
